<template>
  <el-pagination
    background
    :layout="layoutStr"
    :current-page="page"
    :page-sizes="pageSizes"
    :page-size="pageSize"
    :total="pageTotal"
    :pager-count="pagerCount"
    :hide-on-single-page="isPageSizes ? (pageTotal ? false : true) : true"
    @current-change="changePage"
    @size-change="changeSize"
  />
</template>
<script>
export default {
  name: "Page",
  props: {
    // 总条数
    pageTotal: {
      type: Number,
      default: 0
    },
    // 每页显示条目个数
    pageSize: {
      type: Number,
      default: 15
    },
    // 重置分页
    page: {
      type: Number,
      default: 1
    },
    // 是否调整每页显示条数
    isPageSizes: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      layoutStr: "prev, pager, next, jumper",
      pageSizesArr: [10, 30, 50],
      pagerCount: 5 // 页码按钮的数量
    };
  },
  computed: {
    pageSizes() {
      if (!this.isPageSizes) {
        return [];
      }
      let isNext = false;
      const pageSizes = this.pageSizesArr.filter((n, i) => {
        if (n <= this.pageTotal || !isNext) {
          if (n >= this.pageTotal) {
            isNext = true;
          }
          return true;
        }
      });
      if (
        this.pageSizesArr.includes(this.pageSize) &&
        !pageSizes.includes(this.pageSize)
      ) {
        pageSizes.push(this.pageSize);
      }
      return pageSizes.sort();
    }
  },
  mounted() {
    if (this.isPageSizes) {
      this.layoutStr = this.layoutStr
        .slice(0, 0)
        .concat("sizes, ", this.layoutStr);
    }
  },
  methods: {
    changePage(page) {
      this.$emit("changePage", page);
    },
    changeSize(val) {
      this.$emit("changeSize", val);
    }
  }
};
</script>
<style lang="less">
.el-pagination {
  text-align: center;
  margin: 30px auto;
}
</style>
